module.exports = __webpack_public_path__ + "static/success2-b6d95d5c5dca4542303e3f9e7436f50c.png";